module.exports = __webpack_public_path__ + "static/img/gj008.d297d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/financialAudit/gj008.png
// module id = MWtx
// module chunks = 1